/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerSortComponent', [
    '$timeout',
    'DesignerComponent',
    'DesignerSchema',

    function ($timeout, DesignerComponent, DesignerSchema) {
      function DesignerSortComponent() {
        DesignerComponent.apply(this);

        this.fields = [];
      }

      DesignerSortComponent.prototype = new DesignerComponent();

      DesignerSortComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          fields: this.fields || [],
        });

        return data;
      };

      DesignerSortComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerSortComponent.prototype.setData = function (data) {
        this.fields = data.fields;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerSortComponent.prototype.getSchema = function () {
        const schema = DesignerComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerSortComponent;
    },
  ]);
})(window.angular);
